import React, { useState } from 'react';

import { StackView } from '@telus-uds/components-web';

import { initialFieldData } from './util';

import DefectWebform from './fields/defectWebform';
import DefectCategory from './fields/defectCatagory';
import DefectPriority from './fields/defectPriority';
import DefectIssueSummary from './fields/defectIssueSummary';
import DefectErrorMessage from './fields/defectErrorMessage';
import DefectStepsToReplicate from './fields/defectStepsToReplicate';
import SubmitButton from './fields/button';
import DefectAttachment from './fields/defectAttachment';
import DefectWebformOrderId from './fields/DefectWebformOrderId';

const Form = () => {
  const [fieldData, setFieldData] = useState(initialFieldData);
  const [formErrors, setFormErrors] = useState({});

  return (
    <>
      <StackView space={4} tag="section">
        <DefectWebform
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectCategory
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectPriority
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectIssueSummary
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectWebformOrderId
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectErrorMessage
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectStepsToReplicate
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
        <DefectAttachment fieldData={fieldData} setFieldData={setFieldData} />
        <SubmitButton
          fieldData={fieldData}
          setFieldData={setFieldData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
      </StackView>
    </>
  );
};

export default Form;
